/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentProtocolForm } from './IncidentProtocolForm';
import {
    IncidentProtocolFormFromJSON,
    IncidentProtocolFormFromJSONTyped,
    IncidentProtocolFormToJSON,
} from './IncidentProtocolForm';

/**
 * 
 * @export
 * @interface CreateProtocolForm200Response
 */
export interface CreateProtocolForm200Response {
    /**
     * 
     * @type {IncidentProtocolForm}
     * @memberof CreateProtocolForm200Response
     */
    data?: IncidentProtocolForm;
}

/**
 * Check if a given object implements the CreateProtocolForm200Response interface.
 */
export function instanceOfCreateProtocolForm200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateProtocolForm200ResponseFromJSON(json: any): CreateProtocolForm200Response {
    return CreateProtocolForm200ResponseFromJSONTyped(json, false);
}

export function CreateProtocolForm200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProtocolForm200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : IncidentProtocolFormFromJSON(json['data']),
    };
}

export function CreateProtocolForm200ResponseToJSON(value?: CreateProtocolForm200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': IncidentProtocolFormToJSON(value.data),
    };
}

